const info = 'info';
const success = 'success';
const warning = 'warning';
const danger = 'danger';
const refresh = 'refresh';

export { info, success, warning, danger, refresh };
